import { render, staticRenderFns } from "./indexTable.vue?vue&type=template&id=62c8e765&scoped=true&"
import script from "./indexTable.vue?vue&type=script&lang=js&"
export * from "./indexTable.vue?vue&type=script&lang=js&"
import style0 from "./indexTable.vue?vue&type=style&index=0&id=62c8e765&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8e765",
  null
  
)

export default component.exports